import { useEffect, useState } from 'react';
import { salvarCache, recuperarCache } from '../services/cacheHandler';

export function useConfigCache(storageKey) {
    const [salvarConfig, setSalvarConfig] = useState(false);
    const [configSelecionadas, setConfigSelecionadas] = useState([]);

    useEffect(() => {
        async function fetchConfig() {
            const saved = recuperarCache(storageKey); // agora usa método padrão do sistema
            if (saved) {
                try {
                    const arr = JSON.parse(saved);
                    if (Array.isArray(arr)) {
                        setSalvarConfig(true);
                        setConfigSelecionadas(arr);
                    }
                } catch (e) {
                    setSalvarConfig(false);
                    setConfigSelecionadas([]);
                }
            }
        }
        fetchConfig();
    }, [storageKey]);

    // Função para salvar de forma padrão
    const setConfigSelecionadasPadrao = (arr) => {
        setConfigSelecionadas(arr);
        salvarCache(storageKey, JSON.stringify(arr));
    };

    return {
        salvarConfig,
        setSalvarConfig,
        configSelecionadas,
        setConfigSelecionadas: setConfigSelecionadasPadrao
    };
}
